<div class="background"></div>

<article class="content">
  <h1 class="title">Chi siamo</h1>
  <img src="/images/photo17.JPG" class="about-us-img" alt="La comunità ComeTralci" />
  <div id="payload-chi-siamo" [innerHTML]="html"></div>
</article>
